import { useVuelidate } from '@vuelidate/core'
import { unref } from 'vue'

function isValidationNode(node) {
  return node != null && typeof node === 'object' && '$invalid' in node
}

function isFieldNode(node) {
  return isValidationNode(node) && ('$model' in node || '$dirty' in node || '$error' in node)
}

function legacyRule(ruleNode) {
  // Vuelidate 1: true = правило прошло, false = не прошло (`!$v.field.required`)
  return !ruleNode.$invalid
}

function wrapField(fieldNode) {
  if (!fieldNode || typeof fieldNode !== 'object') {
    return fieldNode
  }

  return new Proxy(fieldNode, {
    get(target, prop) {
      if (typeof prop === 'string' && prop.startsWith('$')) {
        return target[prop]
      }

      const child = target[prop]
      if (child == null) {
        return child
      }

      if (typeof child === 'object' && isValidationNode(child)) {
        if (isFieldNode(child)) {
          return wrapField(child)
        }
        return legacyRule(child)
      }

      if (typeof child === 'object') {
        return wrapField(child)
      }

      return child
    },
  })
}

export function createLegacyValidationProxy(v$) {
  const root = unref(v$)
  if (!root) {
    return {}
  }

  return new Proxy(root, {
    get(target, prop) {
      if (typeof prop === 'string' && prop.startsWith('$')) {
        const value = target[prop]
        return typeof value === 'function' ? value.bind(target) : value
      }

      const child = target[prop]
      if (child == null) {
        return child
      }

      if (typeof child === 'object' && isFieldNode(child)) {
        return wrapField(child)
      }

      if (typeof child === 'object' && isValidationNode(child)) {
        return wrapField(child)
      }

      return child
    },
  })
}

export function installVuelidateLegacy(Vue) {
  Vue.mixin({
    setup() {
      return { v$: useVuelidate() }
    },
    computed: {
      $v() {
        return createLegacyValidationProxy(this.v$)
      },
    },
  })
}
